import { Slide } from "@jelly/lesson";
import config from "appConfig";

import { task as task01 } from "../../../../../task/course-03/lesson-03/task-01";

const task: Slide = {
  layout: {
    type: "table",
    options: {
      cols: 2,
      rows: 2,
      rowsSize: [0.9, 3],
      colSpan: {
        "1:0": 2,
      },
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data:
                    "Let f(t) be the following function. Among the four<br>possible choices what is the autoconvolution of f(t)<br>(i.e. the convolution of f(t) by itslef)?",
                  scrollbars: false,
                  formatter: "html",
                  styles: {
                    fontWeight: 700,
                    textAlign: "center",
                  },
                },
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/03/03/task/task-1.svg`,
                },
              },
              styles: {
                maxHeight: "150px",
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task01.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
